require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")
require("jquery/dist/jquery.min")
require("bootstrap/dist/js/bootstrap.min")
require("admin-lte/dist/js/adminlte.min")
require("cocoon")
require("slick-carousel")
require("moment")
require("moment/locale/ja");
require("../src/daterangepicker")
const images = require.context('../images', true)
const imagePath = name => images(name, true);

global.$ = jQuery;

import '../src/date_picker'

import '../src/customer/flash'
import '../src/customer/drop_down'
import '../src/customer/payment'
import '../src/customer/cancel_refund'
import '../src/customer/clipboard'
import '../src/customer/event_user_registration'
import '../src/customer/event_category_selection'
import '../src/customer/barbecue/right_panel'
import '../src/customer/barbecue_camping_rental'
import '../src/customer/barbecue_plan'
import '../src/customer/barbecue_option'
import '../src/customer/barbecue_user_registration'
import '../src/customer/camping_check_option'
import '../src/customer/camping_rental_and_consumable_item'
import '../src/customer/camping_barbecue_plan'
import '../src/customer/camping_user_registration'
import '../src/customer/camping_subscription_user_registration'
import '../src/customer/camping_reservation_subscription_word'
import '../src/customer/event_banner_carousel'
import '../src/customer/inquiry_bank_transfer'
import '../src/customer/creditcard_registration'
import '../src/customer/camping_subscription_creditcard_registration'
import '../src/customer/show_security_code_explanation'
import '../src/customer/barbecue_calendar'
import '../src/customer/disabled_before_selected_payment_method'
import '../src/customer/camping_options'
//import '../src/customer/disabled_when_barbecue_person_zero_num'
//import '../src/customer/disabled_when_camping_person_zero_num'
import '../src/customer/show_creditcard_form'
// import '../src/customer/sidebar_fixed'
import '../src/customer/sitemap_open'
import '../src/customer/webfontloader'
import '../src/customer/show_barbecue_area_modal'
import '../src/customer/show_camping_area_modal'
import '../src/customer/show_camping_option_modal'
import '../src/customer/show_camping_event_modal'
import '../src/customer/categories_reservation_history'
import '../src/customer/anchor_scroll'
import '../src/customer/withdrawal_active_or_disabled_button'
import '../src/customer/camping_subscription_withdrawal_active_or_disabled_button'
import '../src/customer/camping_subscription_plan_active_or_disabled_button'
import '../src/customer/camping_subscription_plan_edit'
import '../src/customer/sp_navbar_toggle'
import '../src/customer/form_input'
import '../src/customer/limit_camping_reservation_checkin_time'
import '../src/customer/day_camping/day_camping_reservations/new'
import '../src/customer/day_camping/rental_and_consumable_items/new'
import '../src/customer/day_camping/options/new'
import '../src/customer/day_camping/guests/new'
import '../src/customer/day_camping/payments/new'
import '../src/customer/day_camping/right_panel'
import '../src/customer/barbecue_menu_fixed'
import '../src/customer/day_camping_menu_fixed'
import '../src/customer/mypage/coupons/index'
import '../src/customer/barbecue_menu_fixed'
import '../src/customer/barbecue/guests/new'
import '../src/customer/camping/camping_reservations/new'
import '../src/customer/camping/guests/new'
import '../src/customer/camping/right_panel'
import '../src/customer/mypages/show'
import '../src/customer/mypage/day_camping/additional_payments/new'
import '../src/customer/mypage/breakdown'
import '../src/customer/recruitment_applications/new'
import '../src/customer/inquiry'

import '../stylessheets/application'
